import { render, staticRenderFns } from "./log-warning.vue?vue&type=template&id=104f4a07&scoped=true&lang=pug"
import script from "./log-warning.vue?vue&type=script&lang=js"
export * from "./log-warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f4a07",
  null
  
)

export default component.exports